export class User {
  uuid: string;
  firstName: string;
  lastName: string;
  confirmed = false;
  email_domain_approved = false;
  invited = true;
  email: string;
  owner = false;
  rank: string;
  profilePicture: any;
  hasProfilePic = false;
  isAdmin = false;
  joinedDate: Date;
  roles: {
    uuid: string,
    description: string,
    is_admin: boolean,
    name: string,
    permissions: {
      uuid: string,
      name: string,
      description: string
    }[],
  }[];

  setUUID(uuid: string): User {
    this.uuid = uuid;
    return this;
  }

  setFirstName(firstName: string): User {
    this.firstName = firstName;
    return this;
  }

  setLastName(lastName: string): User {
    this.lastName = lastName;
    return this;
  }

  setRank(rank: string): User {
    this.rank = rank;
    return this;
  }

  setConfirmed(confirmed: boolean): User {
    this.confirmed = confirmed;
    return this;
  }

  setEmailDomainApproved(email_domain_approved: boolean): User {
    this.email_domain_approved = email_domain_approved;
    return this;
  }

  setInvited(invited: boolean): User {
    this.invited = invited;
    return this;
  }

  setEmail(email: string): User {
    this.email = email;
    return this;
  }

  setProfilePicture(image: string): User {
    this.profilePicture = image;
    return this;
  }

  setHasProfilePic(): User {
    this.hasProfilePic = true;
    return this;
  }

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }
}
